import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-rodo',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './rodo.component.html',
  styleUrl: './rodo.component.scss'
})
export class RodoComponent {}
